interface Props {
    text: string;
    value: string;
    onClick: (value: string) => void;
}

export const Example = ({ text, value, onClick }: Props) => {
    return (
        <a className="eq-example-button p-[20px] w-56 h-full font-normal" onClick={() => onClick(value)}>
            <span className="whitespace-normal normal-case text-left text-sm">
                <span>{text}</span>
            </span>
        </a>
    );
};
